import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};
const MessengerIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3050_186364)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1925 14.9629L10.1366 11.7037L4.17394 14.9629L10.7329 7.99988L13.8634 11.2592L19.7516 7.99988L13.1925 14.9629ZM12 0C5.37262 0 0 4.97456 0 11.1111C0 14.6077 1.74506 17.7266 4.47206 19.7634V24L8.55787 21.7575C9.64837 22.0592 10.8036 22.2221 12 22.2221C18.6274 22.2221 24 17.2476 24 11.1111C24 4.97456 18.6274 0 12 0Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_3050_186364">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MessengerIcon;
